export class Region {
    public academicRegionLabel: string;
    public academies: Academy[];
    public contactEmail: string;
    public nbDemandesHorsRegion: number;
    public aDeuxUniversites: boolean;

    constructor(academicRegionLabel, academies) {
        this.academicRegionLabel = academicRegionLabel;
        this.academies = academies;
    }
}

export class Academy {
    public academyLabel: string;
    public academyCode: string;
    public academicRegionLabel: string;

    constructor(academyLabel, academyCode) {
        this.academyLabel = academyLabel;
        this.academyCode = academyCode;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/region.model.ts